// Textos de la tienda en español neutro con tuteo (DESIGN.md → Tono de voz). Un solo lugar para revisarlos.
// Los textos de marca de Renew MD están adaptados de renew-md.vercel.app y son editables: confirmar con la marca.
// La versión en inglés (en.ts) tiene la misma forma; al cambiar de idioma, content/idioma.ts copia sus textos aquí.
export const es = {
  tituloDocumento: 'Renew MD™ · Tienda de maquillaje y belleza',
  idioma: { otro: 'en', nombreOtro: 'English', cambiar: 'Ver la tienda en inglés' },
  marca: 'Renew MD',
  lema: 'Maquillaje y belleza',
  marcaMarca: '™',
  zona: 'Tienda',
  saltar: 'Saltar al contenido',
  navegacionPrincipal: 'Principal',
  inicio: {
    tituloPagina: 'Renew MD: maquillaje y belleza con una nueva mirada',
    carrusel: {
      etiqueta: 'Promociones y colecciones',
      anterior: 'Banner anterior',
      siguiente: 'Banner siguiente',
      pausar: 'Pausar el avance automático',
      reanudar: 'Reanudar el avance automático',
      posicion: (n: number, total: number) => `${n} de ${total}`,
      irA: (n: number, titulo: string) => `Ver banner ${n}: ${titulo}`,
      diapositivas: [
        {
          etiqueta: 'Nueva colección',
          titulo: 'Maquillaje y belleza con una nueva mirada',
          texto: 'Innovación inspirada en la ciencia para tu rutina diaria. Elige, paga por SPEI y recibe en tu domicilio.',
          cta: 'Comprar ahora',
          href: '/catalogo',
          foto: '1631214524085-17874764a0e5',
          alt: 'Labiales líquidos y muestras de color sobre un fondo rosa',
        },
        {
          etiqueta: 'Rostro',
          titulo: 'Tu rutina completa en cinco minutos',
          texto: 'Base ligera, rubor y polvo compacto para un acabado natural que dura todo el día.',
          cta: 'Ver productos de rostro',
          href: '/catalogo?categoria=rostro',
          foto: '1758272421370-4c01b8084130',
          alt: 'Mujer joven aplicándose maquillaje frente al espejo',
        },
        {
          etiqueta: 'Para negocios',
          titulo: 'Precio de socio para tu salón o tienda',
          texto: 'Registra tu empresa, verifica tu cuenta y compra al precio de tu lista.',
          cta: 'Registrar empresa',
          href: '/registro-empresa',
          foto: '1631730486572-226d1f595b68',
          alt: 'Frascos y estuches de cosméticos sobre un fondo rosa',
        },
      ],
    },
    categorias: 'Compra por categoría',
    novedades: 'Novedades',
    recomendados: 'Recomendados',
    estanteAnterior: (titulo: string) => `Ver anteriores en ${titulo}`,
    estanteSiguiente: (titulo: string) => `Ver más en ${titulo}`,
    categoriasDestacadas: [
      {
        categoria: 'labios',
        etiqueta: 'Labios',
        titulo: 'Color que se queda contigo',
        texto: 'Labiales mates, satinados y brillos de larga duración.',
        cta: 'Comprar labios',
        estante: 'Para tus labios',
        foto: '1487412947147-5cebf100ffc2',
        alt: 'Primer plano de unos labios mientras se aplica labial',
      },
      {
        categoria: 'ojos',
        etiqueta: 'Ojos y cejas',
        titulo: 'Una mirada definida',
        texto: 'Sombras, máscara, delineador y lápiz de cejas para cada estilo.',
        cta: 'Comprar ojos',
        estante: 'Ojos y cejas',
        foto: '1554226629-2af69efaa2fb',
        alt: 'Mujer aplicándose sombra de ojos con brillo',
      },
      {
        categoria: 'rostro',
        etiqueta: 'Rostro y piel',
        titulo: 'Piel cuidada, acabado ligero',
        texto: 'Bases, polvos, iluminadores y sérum para preparar y fijar.',
        cta: 'Comprar rostro',
        estante: 'Rostro y piel',
        foto: '1748543669178-efd3de4e64e0',
        alt: 'Gotas de sérum transparente junto a unas hojas verdes',
      },
    ],
    confianzaEtiqueta: 'Cómo compras en Renew MD',
    confianza: [
      { titulo: 'Envío a todo México', texto: 'Con guía de rastreo en cada pedido.' },
      { titulo: 'Paga por SPEI', texto: 'Una referencia única por pedido.' },
      { titulo: 'Atención en español e inglés', texto: 'Un equipo listo para ayudarte.' },
    ],
    socio: {
      titulo: '¿Tienes tienda, salón o distribuidora?',
      texto: 'Registra tu empresa y verifica tu cuenta para ver tu precio de socio.',
      cta: 'Registrar empresa',
    },
  },
  ayuda: {
    titulo: 'Ayuda',
    intro: 'Cómo comprar, qué nos hace distintos y respuestas a las preguntas más comunes.',
  },
  demo: {
    aviso: 'Demostración con datos de ejemplo',
    detalle: 'Productos, precios y pedidos son ficticios: no se cobra ni se envía nada.',
    verComo: 'Ver como',
    cliente: 'Cliente',
    socio: 'Socio verificado',
    equipo: 'Simular al equipo',
    sinPaso: 'Haz un pedido para simular el trabajo del equipo',
    verificar: 'Verificar mi empresa',
    reiniciar: 'Reiniciar',
    reiniciada: 'La demostración volvió a su estado inicial.',
    pasoHecho: 'Listo: el pedido avanzó un paso.',
    verificada: 'Tu empresa quedó verificada y ya ves tus precios.',
    servidor: {
      banco: 'Banco de ejemplo',
      beneficiario: 'Renew MD (cuenta de ejemplo)',
      paqueteria: 'Paquetería de ejemplo',
      notas: {
        creado: 'Pedido creado',
        comprobante: 'Comprobante recibido',
        conciliado: 'Pago conciliado',
        preparando: 'Preparando tu pedido',
        enviado: 'Enviado con la paquetería',
        entregado: 'Entregado',
        cancelado: 'Cancelado por el cliente',
      },
      pasos: { conciliar: 'Conciliar el pago', preparar: 'Empezar a preparar', enviar: 'Marcar como enviado', entregar: 'Marcar como entregado' },
      errores: {
        noDisponible: 'Un producto del pedido ya no está disponible.',
        cantidad: (producto: string, min: number, mult: number) => `La cantidad de ${producto} debe ser de al menos ${min} y en múltiplos de ${mult}.`,
        sinPrecio: (producto: string) => `El producto ${producto} no tiene precio vigente.`,
        sesion: 'Debes iniciar sesión.',
        items: 'El pedido debe tener entre 1 y 50 productos.',
        faltaEntrega: (campo: string) => `Falta el dato de entrega: ${campo}.`,
        codigoPostal: 'El código postal debe tener 5 números.',
        demasiados: 'Tienes demasiados pedidos sin pagar. Paga o cancela alguno antes de crear otro.',
        noComprobante: 'Este pedido ya no admite comprobantes.',
        noCancelable: 'Este pedido ya no se puede cancelar.',
        yaEmpresa: 'Ya tienes una empresa registrada.',
        noIncluye: (nombre: string) => `La demostración no incluye ${nombre}.`,
        generico: 'Error en la demostración.',
      },
    },
  },
  tipoCambio: (tc: string, fecha: string) => `Precios fijados en dólares (US$) y convertidos a pesos: 1 US$ = $${tc} MXN al ${fecha}. Al crear tu pedido, el tipo de cambio queda fijo.`,
  nav: { productos: 'Productos', miEmpresa: 'Mi empresa', pedidos: 'Mis pedidos', carrito: 'Carrito', ingresar: 'Ingresar', salir: 'Cerrar sesión' },
  portada: {
    etiqueta: 'Maquillaje y belleza',
    titular: 'El maquillaje de hoy',
    acento: 'empieza aquí.',
    intro: 'Una forma nueva de descubrir maquillaje y belleza, con información clara de cada producto y atención en español.',
    explorar: 'Explorar productos',
    conocer: 'Conocer la marca',
    tarjetas: ['Rostro', 'Ojos', 'Labios'],
    valores: ['Alianzas estratégicas', 'Mercados en crecimiento', 'Productos innovadores', 'Un mañana más sólido'],
  },
  productos: {
    etiqueta: 'Nuestros productos',
    titulo: 'Maquillaje. Color. Un mañana más brillante.',
    intro: 'Explora la colección. Haz preguntas. Encuentra información clara para tu siguiente paso.',
    verTodos: 'Ver todo el catálogo',
  },
  areas: {
    etiqueta: 'Categorías',
    titulo: 'Seis categorías. Un estándar de calidad.',
    intro: 'Un portafolio enfocado en lo que usas todos los días.',
    items: [
      { slug: 'rostro', nombre: 'Rostro' },
      { slug: 'ojos', nombre: 'Ojos' },
      { slug: 'labios', nombre: 'Labios' },
      { slug: 'cejas', nombre: 'Cejas' },
      { slug: 'piel', nombre: 'Piel' },
      { slug: 'accesorios', nombre: 'Accesorios' },
    ],
  },
  porque: {
    etiqueta: 'Por qué Renew MD',
    titulo: 'Calidad primero.',
    acento: 'Innovación siempre.',
    items: [
      { titulo: 'Abastecimiento con criterio', texto: 'Buscamos trabajar con proveedores calificados y damos prioridad a la documentación y a los estándares aplicables.' },
      { titulo: 'Información clara y honesta', texto: 'Datos precisos de cada producto y expectativas realistas, para que elijas con criterio.' },
      { titulo: 'Español e inglés', texto: 'Atención bilingüe para que el idioma nunca sea una barrera entre tú y la información.' },
      { titulo: 'Las personas al centro', texto: 'Un equipo atento para responder dudas sobre productos, disponibilidad y siguientes pasos.' },
    ],
  },
  como: {
    etiqueta: 'Cómo funciona',
    titulo: 'Cuatro pasos sencillos hasta tu próxima decisión.',
    pasos: [
      { titulo: 'Explora', texto: 'Recorre la colección y conoce el uso y la presentación de cada producto.' },
      { titulo: 'Crea tu cuenta', texto: 'Ingresa con tu correo. Si eres tienda o socio, registra tu empresa.' },
      { titulo: 'Verificamos a los socios', texto: 'Revisamos los documentos de las empresas y asignamos su precio especial.' },
      { titulo: 'Elige con confianza', texto: 'Compara presentaciones y precios, con la información completa a la vista.' },
    ],
    cta: 'Empezar a explorar',
  },
  alianza: {
    etiqueta: 'Personas. Propósito. Posibilidad.',
    titulo: 'Construyamos juntos un mañana más sólido.',
    texto: 'Conecta con Renew MD para alianzas comerciales y desarrollo de mercado en México.',
    cta: 'Registrar mi empresa',
  },
  faq: {
    etiqueta: 'Información clara',
    titulo: 'Buenas preguntas. Respuestas claras.',
    items: [
      { p: '¿Qué es Renew MD?', r: 'Una marca de belleza y bienestar. Esta tienda reúne su maquillaje y la información de cada producto.' },
      { p: '¿Cómo veo los precios?', r: 'Cada producto muestra su precio de lista. Las empresas verificadas ven además su precio especial.' },
      { p: '¿Cómo me convierto en socio?', r: 'Registra tu empresa, sube tus documentos y el equipo los revisa. Te avisamos el resultado por correo.' },
      { p: '¿Hay información en español?', r: 'Sí. Toda la tienda está en español.' },
    ],
  },
  mision: {
    etiqueta: 'Nuestra misión juntos',
    titulo: 'Gente de calidad. Posibilidades más grandes.',
    texto: 'Sé parte de una visión para impulsar la belleza y el bienestar en México.',
    cta: 'Registrar mi empresa',
  },
  acceso: {
    titulo: 'Ingresar',
    intro: 'Ingresa con tu correo y tu contraseña, o crea una cuenta en un momento.',
    introEnlace: 'Escribe tu correo y te enviaremos un enlace para entrar. Si aún no tienes cuenta, se crea al abrir el enlace.',
    usarEnlace: 'Prefiero entrar con un enlace al correo',
    usarPassword: 'Prefiero usar mi contraseña',
    nuevaTitulo: 'Elige tu contraseña',
    nuevaIntro: 'Escribe la contraseña con la que vas a entrar a la tienda.',
    cargando: 'Revisando tu sesión…',
    correo: 'Correo',
    enviarEnlace: 'Enviar enlace',
    enviando: 'Enviando…',
    enviadoTitulo: 'Revisa tu correo',
    enviadoTexto: 'Te enviamos un enlace para entrar. Puede tardar un par de minutos; revisa también la carpeta de spam.',
    usarOtroCorreo: 'Usar otro correo',
    errorEnvio: 'No pudimos enviar el enlace. Espera unos minutos e inténtalo de nuevo.',
  },
  catalogo: {
    titulo: 'Productos',
    intro: 'Maquillaje y belleza de Renew MD. El precio de lista es para todas las personas; las empresas verificadas ven su precio especial.',
    cargando: 'Cargando los productos…',
    vacioTitulo: 'Pronto habrá productos aquí',
    vacioTexto: 'Estamos preparando la colección. Vuelve en unos días.',
    errorTitulo: 'No pudimos cargar los productos',
    errorTexto: 'Revisa tu conexión e inténtalo de nuevo. Si el problema sigue, escribe a soporte.',
    sinConexionTitulo: 'La tienda no está configurada en este entorno',
    sinConexionTexto: 'Falta la dirección o la llave pública de la base de datos.',
    reintentar: 'Intentar de nuevo',
    filtros: 'Filtrar por categoría',
    todos: 'Todos',
    sinImagen: 'Sin imagen',
    desde: 'Desde',
    precioLista: 'Precio de lista',
    precioSocio: 'Tu precio de socio',
    sinPrecio: 'Precio por confirmar',
    verProducto: 'Ver producto',
    volver: 'Volver a productos',
    presentaciones: 'Presentaciones',
    ingredientes: 'Ingredientes',
    modoDeUso: 'Modo de uso',
    iva: 'IVA incluido en el precio final del pedido',
    socioInvitacion: 'Si eres tienda o socio, registra tu empresa para ver tu precio especial.',
    noExiste: 'Ese producto no existe o ya no está disponible.',
  },
  registro: {
    titulo: 'Registra tu empresa',
    intro: 'Son cuatro pasos. Puedes salir y continuar después: lo que guardes se conserva.',
    pasos: ['Datos fiscales', 'Responsable sanitario', 'Sucursal de entrega', 'Documentos'],
    guardando: 'Guardando…',
    guardarYSeguir: 'Guardar y continuar',
    eligeOpcion: 'Elige una opción',
    atras: 'Atrás',
    errorGenerico: 'No pudimos guardar. Inténtalo de nuevo en unos minutos.',
    cargando: 'Preparando tu registro…',
    necesitaSesion: 'Para registrar tu empresa, primero ingresa con tu correo.',
    fiscal: {
      razonSocial: 'Razón social',
      rfc: 'RFC',
      ayudaRfc: 'Con homoclave, por ejemplo XAXX010101000. Después de guardar solo EG puede cambiarlo.',
      tipo: 'Tipo de empresa',
      tipos: { farmacia: 'Farmacia', clinica: 'Clínica', consultorio: 'Consultorio', distribuidor: 'Distribuidor' },
      codigoPostal: 'Código postal fiscal',
      correo: 'Correo de facturación',
      telefono: 'Teléfono (opcional)',
      rfcRepetido: 'Ya hay una empresa registrada con ese RFC. Si es la tuya, pide acceso a quien la registró.',
      maximo: 'Esta cuenta ya llegó al máximo de empresas registradas.',
    },
    sanitario: {
      intro: 'Necesitamos al menos un aviso de funcionamiento o una licencia sanitaria, y a tu responsable sanitario.',
      aviso: 'Número de aviso de funcionamiento',
      licencia: 'Número de licencia sanitaria',
      responsable: 'Nombre del responsable sanitario',
      cedula: 'Cédula profesional del responsable',
      faltaAviso: 'Escribe el aviso de funcionamiento o la licencia sanitaria.',
    },
    sucursal: {
      alias: 'Nombre de la sucursal',
      calle: 'Calle',
      numeroExterior: 'Número exterior',
      numeroInterior: 'Número interior (opcional)',
      colonia: 'Colonia',
      municipio: 'Alcaldía o municipio',
      estado: 'Estado',
      codigoPostal: 'Código postal',
      contacto: 'Persona de contacto',
      telefono: 'Teléfono de contacto',
      horario: 'Horario de recepción (opcional)',
      referencias: 'Referencias para llegar (opcional)',
    },
    documentos: {
      intro: 'Sube cada documento en PDF, JPG o PNG, de hasta 10 MB. Los revisa el equipo de EG.',
      tipos: {
        constancia_situacion_fiscal: 'Constancia de situación fiscal',
        aviso_funcionamiento: 'Aviso de funcionamiento',
        licencia_sanitaria: 'Licencia sanitaria',
        cedula_responsable: 'Cédula del responsable sanitario',
        otro: 'Otro documento',
      },
      subir: 'Subir archivo',
      subiendo: 'Subiendo…',
      subido: 'Subido',
      errorTipo: 'El archivo debe ser PDF, JPG o PNG.',
      errorPeso: 'El archivo pesa más de 10 MB.',
      errorSubida: 'No pudimos subir el archivo. Inténtalo de nuevo.',
      terminar: 'Terminar registro',
      faltan: 'Sube al menos la constancia fiscal y la cédula del responsable para terminar.',
    },
    privacidad: 'Acepto el aviso de privacidad de Renew MD.',
    privacidadError: 'Para continuar, acepta el aviso de privacidad.',
    listoTitulo: 'Registro enviado',
    listoTexto: 'EG revisará tus documentos. Te avisaremos por correo cuando termine la revisión.',
  },
  miEmpresa: {
    titulo: 'Mi empresa',
    sinEmpresaTitulo: 'Aún no registraste una empresa',
    sinEmpresaTexto: 'Para ver precios y comprar, registra tu empresa y envía tus documentos a revisión.',
    registrar: 'Registrar mi empresa',
    continuar: 'Continuar mi registro',
    estados: {
      pendiente: 'En revisión',
      verificada: 'Verificada',
      rechazada: 'Rechazada',
      suspendida: 'Suspendida',
    },
    estadoTexto: {
      pendiente: 'EG está revisando tu información. Mientras tanto puedes ver el catálogo, sin precios.',
      verificada: 'Tu empresa está verificada. Ya ves tus precios en el catálogo.',
      rechazada: 'EG no pudo verificar tu empresa. Revisa el motivo y corrige lo que indica.',
      suspendida: 'Tu empresa está suspendida. Escribe a EG para resolverlo.',
    },
    motivo: 'Motivo',
    datos: 'Datos de la empresa',
    documentos: 'Documentos',
    sinDocumentos: 'Aún no subiste documentos.',
    estadosDocumento: { pendiente: 'En revisión', aceptado: 'Aceptado', rechazado: 'Rechazado' },
  },
  guardado: { titulo: 'Guardado', texto: 'Tus datos se guardaron.' },
  // Mensajes de validación: los esquemas guardan la clave y erroresPorCampo() muestra el texto del idioma vigente.
  validacion: {
    razonSocial: 'Escribe la razón social completa.',
    rfc: 'El RFC no tiene un formato válido. Revisa letras, fecha y homoclave.',
    tipoEmpresa: 'Elige el tipo de empresa.',
    codigoPostal: 'El código postal tiene 5 números.',
    correo: 'Escribe un correo válido, por ejemplo facturas@tuempresa.mx.',
    telefono: 'Escribe solo números, de 8 a 20 caracteres.',
    responsable: 'Escribe el nombre del responsable sanitario.',
    cedula: 'La cédula profesional tiene 7 u 8 números.',
    faltaAviso: 'Escribe el aviso de funcionamiento o la licencia sanitaria.',
    alias: 'Escribe un nombre para la sucursal, por ejemplo «Matriz».',
    calle: 'Escribe la calle.',
    numeroExterior: 'Escribe el número exterior.',
    colonia: 'Escribe la colonia.',
    municipio: 'Escribe la alcaldía o el municipio.',
    estado: 'Escribe el estado.',
    contacto: 'Escribe quién recibe los pedidos.',
    nombreRecibe: 'Escribe el nombre de quien recibe.',
  },
  errorTitulo: 'No se pudo completar',
  carrito: {
    titulo: 'Carrito',
    vacioTitulo: 'Tu carrito está vacío',
    vacioTexto: 'Explora los productos y agrega lo que te guste.',
    explorar: 'Explorar productos',
    agregar: 'Agregar al carrito',
    agregado: 'Agregado al carrito',
    verCarrito: 'Ver carrito',
    cantidad: 'Cantidad',
    quitar: 'Quitar',
    noDisponible: 'Este producto ya no está disponible. Quítalo para continuar.',
    sinPrecio: 'Sin precio vigente. Quítalo para continuar.',
    minimo: (min: number, mult: number) => (mult > 1 ? `Mínimo ${min}, de ${mult} en ${mult}` : `Mínimo ${min}`),
    precioIvaIncluido: 'IVA incluido',
    precioMasIva: '+ IVA',
    subtotal: 'Subtotal',
    iva: 'IVA',
    total: 'Total estimado',
    notaEstimado: 'Es un estimado. La tienda confirma el total final al crear tu pedido.',
    continuar: 'Continuar con el pedido',
    precioSocio: 'Precio de socio',
    cargando: 'Preparando tu carrito…',
  },
  checkout: {
    titulo: 'Datos de entrega',
    intro: 'Dinos dónde entregar tu pedido. Después te mostramos cómo pagar.',
    resumen: 'Resumen del pedido',
    crear: 'Crear pedido',
    creando: 'Creando pedido…',
    necesitaSesion: 'Para crear tu pedido, ingresa con tu correo. Tu carrito se conserva.',
    cerradas: 'Las compras todavía no están abiertas. Puedes llenar tu carrito y volver pronto.',
    carritoVacio: 'Tu carrito está vacío.',
    volverCarrito: 'Volver al carrito',
    campos: {
      nombre: 'Nombre de quien recibe',
      telefono: 'Teléfono',
      calle: 'Calle',
      numeroExterior: 'Número exterior',
      numeroInterior: 'Número interior (opcional)',
      colonia: 'Colonia',
      municipio: 'Alcaldía o municipio',
      estado: 'Estado',
      codigoPostal: 'Código postal',
      referencias: 'Referencias para llegar (opcional)',
      notas: 'Notas del pedido (opcional)',
    },
    errorCrear: 'No pudimos crear el pedido. Inténtalo de nuevo.',
    errorTitulo: 'No se pudo crear el pedido',
    creado: 'Pedido creado',
  },
  pedidos: {
    titulo: 'Mis pedidos',
    intro: 'Aquí ves el estado de cada pedido y cómo pagarlo.',
    vacioTitulo: 'Aún no tienes pedidos',
    vacioTexto: 'Cuando hagas tu primer pedido aparecerá aquí.',
    necesitaSesion: 'Ingresa con tu correo para ver tus pedidos.',
    cargando: 'Cargando tus pedidos…',
    error: 'No pudimos cargar tus pedidos. Actualiza la página.',
    pedido: 'Pedido',
    volver: 'Volver a mis pedidos',
    noExiste: 'Ese pedido no existe o no es tuyo.',
    columnas: { pedido: 'Pedido', fecha: 'Fecha', estado: 'Estado', total: 'Total' },
    estados: {
      pendiente_pago: 'Pendiente de pago',
      pago_en_revision: 'Pago en revisión',
      pagado: 'Pagado',
      surtiendo: 'Preparando',
      enviado: 'Enviado',
      entregado: 'Entregado',
      cancelado: 'Cancelado',
    },
    productos: 'Productos',
    entrega: 'Entrega',
    historial: 'Historial',
    resumen: { subtotal: 'Subtotal', iva: 'IVA', envio: 'Envío', total: 'Total' },
    pagoTitulo: 'Cómo pagar',
    pagoIntro: 'Haz una transferencia SPEI por el total exacto y escribe esta referencia en el concepto.',
    referencia: 'Referencia',
    monto: 'Monto',
    banco: 'Banco',
    beneficiario: 'Beneficiario',
    clabe: 'CLABE',
    datosPendientes: 'Todavía no tenemos los datos de la cuenta en la tienda. El equipo te los enviará por correo.',
    subirComprobante: 'Subir comprobante',
    cambiarComprobante: 'Subir otro comprobante',
    subiendo: 'Subiendo…',
    comprobanteTipo: 'El archivo debe ser PDF, JPG o PNG.',
    comprobantePeso: 'El archivo pesa más de 10 MB.',
    comprobanteError: 'No pudimos subir el comprobante. Inténtalo de nuevo.',
    comprobanteEnviado: 'Comprobante enviado',
    comprobanteTexto: 'Lo revisaremos pronto y te avisaremos cuando el pago esté confirmado.',
    enRevision: 'Recibimos tu comprobante y lo estamos revisando.',
    cancelar: 'Cancelar pedido',
    cancelarAyuda: 'Mantén presionado para cancelar',
    cancelado: 'Pedido cancelado',
    guia: 'Guía de rastreo',
    paqueteria: 'Paquetería',
    errorAccion: 'No pudimos completar la acción. Inténtalo de nuevo.',
    errorTitulo: 'No se pudo completar',
  },
  noEncontrada: {
    titulo: 'Esta página no existe',
    texto: 'Revisa la dirección o vuelve a los productos.',
    volver: 'Ir a los productos',
  },
  pie: 'Renew MD. Venta en México. Los precios son en pesos mexicanos.',
  pieNav: 'Pie de página',
  pieEnlaces: { productos: 'Productos', alianza: 'Alianzas', registro: 'Registrar empresa', ayuda: 'Ayuda y preguntas' },
} as const
